import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSocketListener } from "./useSocketListener";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { IUser } from "../contexts/AuthContextProvider";
import { qoTodaysUnit } from "../utils/queryOptions";
import { toast } from "react-toastify";
import { contentPaths } from "../utils/static";
import { useSqids } from "./useSqids";
import { slugify } from "../utils/urlConversion";

export function useUnitRedirect(user: IUser | null) {
  const navigate = useNavigate();
  const location = useLocation();
  const sqids = useSqids();
  const queryClient = useQueryClient();

  const { data: liveUnitDetails } = useQuery(
    qoTodaysUnit({
      cohort_id: user?.cohort_id,
    })
  );

  const url = liveUnitDetails
    ? `/${contentPaths["UNIT"]}/${slugify(liveUnitDetails.name)}-${sqids.encode(
        liveUnitDetails.unit_id
      )}`
    : null;

  const justNavigate = useCallback(() => {
    if (url) {
      navigate(url);
    }
  }, [navigate, url]);

  // zaten sitedeydi
  useSocketListener<string>("unitStartReply", () => {
    if (user && liveUnitDetails?.unit_live_status !== "ONGOING") {
      queryClient
        .invalidateQueries({
          queryKey: ["todaysUnit"],
        })
        .then(() => {
          toast.info("Ders başlıyor!");
        });

      if (location.pathname !== url) {
        setTimeout(() => {
          justNavigate();
        }, 4000);
      } else {
        window.location.reload();
      }
    }
  });

  // siteyi yeni açtı ya da farklı sayfaya gitmeye çalışıyor
  useEffect(() => {
    if (
      user &&
      user.role !== 34 &&
      liveUnitDetails &&
      liveUnitDetails.unit_live_status === "ONGOING" &&
      location.pathname !== url
    ) {
      toast.info("Devam eden derse yönlendiriyorum");
      setTimeout(() => {
        window.location.replace(url!);
      }, 4000);
    }
  }, [user, liveUnitDetails, location, navigate, justNavigate, url]);
}
